export interface FavouriteItemWire {
  v: number;
  d?: string;
  c?: number;
}

export interface FavouriteSearchWire {
  code: FavouriteItemWire;
  owner: FavouriteItemWire;
  parent: FavouriteItemWire;
  disabled: string;
  shared: boolean;
  invalidOwner: boolean;
}

export interface FavouriteAdminListWire {
  totalNumberOfResults: number;
  editableNumberOfResults?: number;
  results: FavouriteSearchWire[];
}

export enum ChangeOptionType {
  Add,
  Replace
}
